import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const BRAND_GREEN = '#0d1f0d';
const BRAND_GOLD  = '#c9a84b';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logoWrap}>
          <img src="/walker-logo-color.png" alt="Walker ClimateCare" style={styles.logo} />
        </div>

        <div style={styles.divider} />

        <p style={styles.subtitle}>Sign in to your account</p>

        {error && <div style={styles.errorBox}>{error}</div>}

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              style={styles.input}
              placeholder="you@example.com"
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={styles.input}
              placeholder="••••••••"
            />
          </div>
          <button type="submit" disabled={loading} style={styles.btn}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
          <div style={{ textAlign: 'center', marginTop: '0.75rem' }}>
            <Link to="/forgot-password" style={styles.forgotLink}>Forgot your password?</Link>
          </div>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: `linear-gradient(160deg, ${BRAND_GREEN} 0%, #060f06 100%)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
  },
  card: {
    background: '#fff',
    borderRadius: '1rem',
    padding: '2rem 2.5rem 2.5rem',
    width: '100%',
    maxWidth: '400px',
    boxShadow: `0 25px 60px rgba(0,0,0,0.6), 0 0 0 1px ${BRAND_GOLD}33`,
  },
  logoWrap: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '1rem',
  },
  logo: {
    width: '220px',
    height: 'auto',
    display: 'block',
  },
  divider: {
    height: '2px',
    background: `linear-gradient(to right, transparent, ${BRAND_GOLD}, transparent)`,
    borderRadius: '1px',
    marginBottom: '1.25rem',
  },
  subtitle: {
    color: '#64748b',
    marginBottom: '1.5rem',
    fontSize: '0.95rem',
    textAlign: 'center',
  },
  errorBox: {
    background: '#fef2f2',
    border: '1px solid #fecaca',
    color: '#dc2626',
    padding: '0.75rem 1rem',
    borderRadius: '0.5rem',
    marginBottom: '1rem',
    fontSize: '0.875rem',
  },
  form: { display: 'flex', flexDirection: 'column', gap: '1rem' },
  field: { display: 'flex', flexDirection: 'column', gap: '0.375rem' },
  label: { fontSize: '0.875rem', fontWeight: '600', color: '#374151' },
  input: {
    padding: '0.625rem 0.875rem',
    border: '1.5px solid #e2e8f0',
    borderRadius: '0.5rem',
    fontSize: '0.95rem',
    outline: 'none',
    transition: 'border-color 0.15s',
  },
  btn: {
    marginTop: '0.5rem',
    padding: '0.75rem',
    background: BRAND_GREEN,
    color: BRAND_GOLD,
    border: `2px solid ${BRAND_GOLD}`,
    borderRadius: '0.5rem',
    fontSize: '1rem',
    fontWeight: '700',
    cursor: 'pointer',
    transition: 'all 0.15s',
    letterSpacing: '0.03em',
  },
  forgotLink: {
    color: BRAND_GREEN,
    textDecoration: 'none',
    fontSize: '0.875rem',
    fontWeight: '500',
  },
};
